export const SHOW_TOAST = 'SHOW_TOAST';
export const showToast = (payload) => ({
    type: SHOW_TOAST,
    payload,
});
//# sourceMappingURL=show-toast-action.js.map